// THEME EDITOR FORMS
export const FORM_THEME_EDITOR_ADVANCED_NAME = 'themeEditorAdvanced';
export const FORM_THEME_EDITOR_BUTTONS_NAME = 'themeEditorButtons';
export const FORM_THEME_EDITOR_COLOR_NAME = 'themeEditorColor';
export const FORM_THEME_EDITOR_COMPLETION_PAGE_NAME = 'themeEditorCompletionPage';
export const FORM_THEME_EDITOR_FAILED_PAGE_NAME = 'themeEditorFailedPage';
export const FORM_THEME_EDITOR_SELECT_COUNTRY_PAGE_NAME = 'themeEditorSelectCountryPage';
export const FORM_THEME_EDITOR_FONT_NAME = 'themeEditorFont';
export const FORM_THEME_EDITOR_START_PAGE_NAME = 'themeEditorStartPage';
export const FORM_THEME_EDITOR_START_PAGE_LOGO_NAME = 'themeEditorStartPageLogo';
export const FORM_THEME_EDITOR_DOCUMENTS_UPLOAD_PAGE_NAME = 'themeEditorDocumentsUploadPage';

// TODO (fawn - future cleanup): remove these
export const FORM_THEME_SET_EDITOR_GENERAL = 'themeSetEditorGeneral';
export const FORM_THEME_SET_EDITOR_INPUT = 'themeSetEditorInput';

// TEMPLATE CONFIG FORM
export const FORM_INQUIRY_TEMPLATE_CONFIG = 'inquiryTemplateConfig';
export const FORM_FLOW_EDITOR = 'flowEditor';

// DEVELOPMENT PAGE
export const FORM_ADD_ALLOWED_HOST = 'addAllowedHost';
export const FORM_ADD_ALLOWED_URI_SCHEME = 'addAllowedUriScheme';

// CASE FORMS
export const FORM_SET_CASE_STATUS = 'setCaseStatus';
export const FORM_CASE_ACTION = 'caseAction';
export const FORM_CASE_FLAG_ISSUES = 'caseFlagIssues';

// VERIFICATION TEMPLATE FORMS
export const FORM_UPDATE_VERIFICATION_TEMPLATE = 'updateVerificationTemplate';

// ORGANIZATION PAGE
export const FORM_ORGANIZATION_DETAILS = 'organizationDetails';

// GRAPH QUERY PAGE
export const FORM_GRAPH_QUERY = 'graphQuery';
// GRAPH CONFIGURATION PAGE
export const FORM_UPDATE_GRAPH_CONFIG = 'updateGraphConfig';
